import create from 'zustand/vanilla';
import reducer, { INITIAL_STATE } from './authReducer';

const authStore = create((set) => ({
  ...INITIAL_STATE,
  dispatch: (args) => set((state) => reducer(state, args)),
}));

export default authStore;
